import { render, staticRenderFns } from "./domaintag.vue?vue&type=template&id=729febfd&scoped=true"
var script = {}
import style0 from "./domaintag.vue?vue&type=style&index=0&id=729febfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729febfd",
  null
  
)

export default component.exports